import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { generateUUID } from 'src/app/shared/utils/functions/codigo-transacao.model';
import { showDefaultError, showError, showNotification, showSucess } from 'src/app/shared/utils/functions/notification.function';
import { safeAsign } from 'src/app/shared/utils/functions/safe-asign.function';
import Swal from 'sweetalert2';
import { ModalDetalhesAtivosComponent } from '../../components/modal-detalhes-ativos/modal-detalhes-ativos.component';
import { SolicitarGarantiaService } from '../../services/solicitar-garantia.service';
import { arrayEstados, Estados } from 'src/app/shared/utils/data/estados.data';

import { BancoService } from '../../services/banco.service';
import cep from 'cep-promise'
import { ModalEditarDadosComponent } from '../../components/modal-editar-dados/modal-editar-dados.component';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import { encryptStorage } from 'src/app/auth/utils/storage';
import { CnpjValidator } from 'src/app/shared/utils/validators/cnpj-validator';
import { UserType } from 'src/app/shared/enum/investor-type.enum';
import { validateTelOrCell } from 'src/app/shared/utils/validators/forms.validators';

export class CodigoAtivo{
  codigoAtivo: string
  dataAquisicao: string
  valorInvestido: string
  dataVencimento: string
}

export class FormAtivo{
  nomeInvestidor: string
  documentoIdentificador: string
  celular: string
  telefone: string
  codCnpj: string
  email: string
  endereco: string = ''
  complemento: string = ''
  bairro: string = ''
  cidade: string = ''
  estado: string = ''
  cep: string = ''
  codigoBanco: string
  agencia: string
  tipoConta: string
  conta: string
  dgAgencia: string
  pais: string = ''
}

export class InvestidorEntidade{
  celular: string;
  telefone: string;
  documentoIdentificador: string
  nomeInvestidor: string;
  email: string;
  tipoInvestidor: string;
}

@Component({
  selector: 'app-solicitar-garantia-dpge',
  templateUrl: './solicitar-garantia-dpge.component.html',
  styleUrls: ['./solicitar-garantia-dpge.component.scss']
})
export class SolicitarGarantiaDpgeComponent implements OnInit, OnDestroy {

  query ={
    codigoTransacao: generateUUID(),
    documentoIdentificador: '',
    codigoCnpj: '',
    codigoAtivo: '',
    tipoUsuario: '',
    cnpjEmpresaEscolhidaCredor: null
  }

  desabilitarBotao: boolean = true

  codigoAtivo: CodigoAtivo = {
    codigoAtivo: '',
    dataAquisicao: '',
    valorInvestido: '',
    dataVencimento: ''
  }

  estados: Estados[] = arrayEstados

  formSolicitacao: FormGroup
  dadosInvestidor: FormGroup
  formSearch: FormGroup;

  tableAtivos: CodigoAtivo[] = []

  solicitarDpge: boolean = false
  dadosInstituicao: any = {
    instituicaoId: '',
    liquidacao: '',
    nome: ''
  }

  p: number = 1
  tableCard: any[] = []
  modalRef: MDBModalRef


  modalCloseEvent: any

  desabilitarEndereco: string = ''
  bancos: any[] = []
  arrayBancos: any [] = []

  constructor(
    private modalService: MDBModalService,
    private bancoService: BancoService,
    private solicitarGarantiaService: SolicitarGarantiaService
  ){}

  ngOnInit(): void {
    var cnpjEscolhidoGarantiaDPGE = localStorage.getItem('cnpjEscolhidoGarantiaDPGE')
    this.query.cnpjEmpresaEscolhidaCredor = cnpjEscolhidoGarantiaDPGE && cnpjEscolhidoGarantiaDPGE !== "undefined" && cnpjEscolhidoGarantiaDPGE !== "null"  ? cnpjEscolhidoGarantiaDPGE : null
    this.query.codigoCnpj = this.dadosInstituicao.instituicaoId
    //Recupera os valores de data liquidacao e nome da instituicao
    this.dadosInstituicao.instituicaoId = localStorage.getItem('id')
    this.dadosInstituicao.liquidacao = localStorage.getItem('dataLiquidacao')
    this.dadosInstituicao.nome = localStorage.getItem('nomeInstituicao')
    this.query.codigoCnpj = localStorage.getItem('id')
    this.query.tipoUsuario = encryptStorage.getItem('@tipoUsuario' , false)
    this.createFormSearch();
    this.createForm(new FormAtivo())
    this.createFormDadosInvestidor(new InvestidorEntidade())
    this.listarAtivos()
    this.listarBancos()

    this.modalCloseEvent = this.modalService.closed.subscribe(
      (modalWasClosed) => this.listarAtivos()
    );
  }

  ngOnDestroy(): void {
    this.modalCloseEvent.unsubscribe();
  }

  addOnTableAtivo(){
    let hasDuplicated: boolean = false


    this.tableAtivos.forEach(ativo => {
      if(ativo.codigoAtivo == this.codigoAtivo.codigoAtivo){
        hasDuplicated = true
      }
    })

    if(hasDuplicated){
      return showError('Código ativo duplicado', 'Você está adicionando um código de ativo já informado.')
    }else{
      this.tableAtivos.push(this.codigoAtivo)
      this.codigoAtivo = {
        codigoAtivo: '',
        dataAquisicao: '',
        valorInvestido: '',
        dataVencimento: ''
      }
    }
  }

  exibirMensagem(codigoStatus, tipoProcesso, idInvestidor){
    if(!safeAsign(codigoStatus) && !safeAsign(tipoProcesso)){
      // console.log('erro api retornando null')
      return showError('Ocorreu um erro', 'Houve um erro ao processar a sua solicitação, tente novamente mais tarde.')
    }

    //Status Processo = codigo status
    //Tipo Processo = Tipo Processo

    let paramAlterar = tipoProcesso == 4 && codigoStatus == 6 ? 'ALTERAR' : ''

    switch (paramAlterar){
      case 'ALTERAR' : {
        this.showModal(idInvestidor)
        break;
      }
      default: {
        let query = {
          stProcesso: codigoStatus,
          tpProcesso: tipoProcesso,
          codigoTransacao: generateUUID()
        }

        this.solicitarGarantiaService.acompanharProcessoSolicitacao(query).subscribe(
          res => showNotification('', res['data']['mensagem']),
          e => showDefaultError(e),
        )
      }
    }
  }


  showModal(dados){
    let config = {
      scroll: true,
      ignoreBackdropClick: true,
      data: {idInvestidor: dados}
    }

    this.modalRef = this.modalService.show(ModalEditarDadosComponent, config)
  }

  listaEnderecoUsuario(){
    let query ={
      codigoTransacao: generateUUID()
    }

    this.solicitarGarantiaService.listarEnderecoUsuario(query).subscribe(
      res => {
        this.desabilitarEndereco = 'disabled'
        this.endereco.setValue(res['data']['endereco'])
        this.cidade.setValue(res['data']['cidade'])
        this.bairro.setValue(res['data']['bairro'])
        this.estado.setValue(res['data']['estado'])
        this.pais.setValue(res['data']['pais']),
        this.cepUsuario.setValue(res['data']['cep'])
        this.complemento.setValue(res['data']['complemento'])
      },
      e => showDefaultError(e),
      () => {}
    )
  }

  validaCodigoAtivo(){

    if(this.query.tipoUsuario == 'ENTIDADE'){
      let isCpf = this.documentoIdentificador.value.length < 14 ? true : false

      if(!safeAsign(this.tipoEntidade.value)){
        return showError('Tipo de usuário', 'Informe um tipo de usuário não informado.')
      }
      if(isCpf){
        if(!cpf.isValid(this.documentoIdentificador.value) && this.tipoEntidade.value == 'pessoaFisica'){
          return showError('CPF Inválido', 'O documento identificador informado não é válido')
        }
      }else{
        if(this.tipoEntidade.value != 'pessoaFisica'){
          try {
            this.documentoIdentificador.setValue(CnpjValidator.create(this.documentoIdentificador.value));
          } catch {
            return showError('CNPJ Inválido', 'O documento identificador informado não é válido')
          }
        }
      }
    }

    var docIdentifier = null;

    switch(this.query.tipoUsuario){
      case 'ENTIDADE':
        docIdentifier = this.documentoIdentificador.value;
        break;
      case 'INVESTIDORPF':
        docIdentifier = encryptStorage.getItem('@documentoIdentificador', false);
        break;
      case 'INVESTIDORPJ':
      case 'INVESTIDORFI':
        docIdentifier = this.query.cnpjEmpresaEscolhidaCredor;
        break;
    }

    let query = {
      codigoTransacao: generateUUID(),
      codigoAtivo: this.codigoAtivo.codigoAtivo,
      documentoIdentificador: docIdentifier,
      raizCnpj: this.dadosInstituicao.instituicaoId
    }

    if(!safeAsign(this.codigoAtivo.codigoAtivo)){
      return showError('','O Campo "Código Ativo" é obrigatório.')
    }

    if(!safeAsign(this.codigoAtivo.dataAquisicao)){
      return showError('','O Campo "Data Aquisição" é obrigatório.')
    }

    return this.solicitarGarantiaService.validarCodigoAtivo(query).subscribe(
      res => this.addOnTableAtivo(),
      e => showDefaultError(e))
  }

  deleteAtivo(item){
    this.validateDelete(item)
  }

  resetForm(){
    this.solicitarDpge = false
    this.tableAtivos = []
    this.createForm(new FormAtivo())
    this.listarAtivos()
  }

  validateDelete(item){
    Swal.fire({
      title: 'Excluir Código Ativo',
      text: `Você deseja excluir o Código Ativo: ${item.codigoAtivo}. a seguir`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      width:'500px',
      padding: '30px',
      confirmButtonText: 'Sim, tenho certeza',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value == true) {
        Swal.fire(
          'Excluído',
          'O Código Ativo foi excluído com sucesso.',
          'success'
        )
      let indexItem = this.tableAtivos.indexOf(item)

       if(indexItem !== -1){
        this.tableAtivos.splice(indexItem, 1)
       }
      }else if(result.dismiss){
        return;
      }
    })
  }

  createFormSearch() {
    this.formSearch = new FormGroup({
      codigoAtivo: new FormControl(''),
      documentoIdentificador: new FormControl('')
    });
  }

  createForm(ativo: FormAtivo){
     this.formSolicitacao = new FormGroup({
      nomeInvestidor: new FormControl(
        encryptStorage.getItem('@user', false)
      ),
      documentoIdentificador: new FormControl(
        encryptStorage.getItem('@documentoIdentificador', false)
      ),
       celular: new FormControl(
         ativo.celular || ''
       ),
       telefone: new FormControl(
         ativo.telefone || ''
       ),
      codCnpj: new FormControl(
        this.dadosInstituicao.instituicaoId
      ),
      email: new FormControl(
        ativo.email
        ),
      endereco: new FormControl(
        ativo.endereco,
        ),
      complemento: new FormControl(
        ativo.complemento,
        ),
      bairro: new FormControl(
        ativo.bairro,
        ),
      cidade: new FormControl(
        ativo.cidade,
        ),
      estado: new FormControl(
        ativo.estado,
        ),
      cep: new FormControl(
        ativo.cep,
        ),
      pais: new FormControl(
        ativo.pais,
        ),
      codigoBanco: new FormControl(
        ativo.codigoBanco,
        [Validators.required]
        ),
      agencia: new FormControl(
        ativo.agencia,
        [Validators.required]
        ),
      tipoConta: new FormControl(
        ativo.tipoConta,
        [Validators.required]
        ),
      conta: new FormControl(
        ativo.conta,
        [Validators.required]
        ),
        dgConta: new FormControl(
          ativo.dgAgencia,
          [Validators.required]
          ),
      dgAgencia: new FormControl(
        ativo.dgAgencia
        )
    },
    {
      validators: [validateTelOrCell]
    }
  )
  }

  createFormDadosInvestidor(investidor){
     this.dadosInvestidor =  new FormGroup({
      tipoInvestidor: new FormControl(investidor.tipoInvestidor, [Validators.required]),
      nomeInvestidor: new FormControl(investidor.nomeInvestidor, [Validators.required]),
       celular: new FormControl(investidor.celular || ''),
       telefone: new FormControl(investidor.telefone || ''),
      email: new FormControl(investidor.email, [Validators.required]),
      documentoIdentificador: new FormControl(investidor.documentoIdentificador, [Validators.required]),
    },
    {
      validators: [validateTelOrCell]
    }
  )
  }

  validateDataBank(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/^(\d*[a-zA-Z]?\d*).*$/, '$1').replace(/[^0-9a-zA-Z]/g, '');
  }

  onBancoChange(codigoBanco: string): void {
    if (codigoBanco !== '001') {
      this.formSolicitacao.get('dgAgencia')?.reset();
    }
  }

  realizarSolicitacao(){
    const codigoBanco = this.codigoBanco.value;
    const bancoSelecionado = this.bancos.find(banco => banco.id === codigoBanco);

    if(this.query.tipoUsuario == 'ENTIDADE') {
      if(!safeAsign(this.documentoIdentificador.value)) {
        return showError('Campos Obrigatórios', 'O Campo CPF / CNPJ é obrigatório')
      }

      if(!safeAsign(this.nome.value)) {
        return showError('Campos Obrigatórios', 'O Campo Nome Investidor é obrigatório')
      }

      if(!safeAsign(this.email.value)) {
        return showError('Campos Obrigatórios', 'O Campo E-Mail é obrigatório')
      }

      if (this.dadosInvestidor.errors?.telOrCellRequired) {
        showError(
          "Atenção",
          "Não foi informado nenhum número de telefone ou de celular"
        );
        return false;
      }
    }

    if(this.tableAtivos.length == 0){
      return showError('Campos Obrigatórios','Você precisa adicionar ao menos um ativo para prosseguir com a solicitação.')
    }

    if(!safeAsign(this.codigoBanco.value)) {
      return showError('Campos Obrigatórios', 'O Campo Banco para Depósito é obrigatório')
    }

    if(!safeAsign(this.tipoConta.value)) {
      return showError('Campos Obrigatórios', 'O Campo Tipo Conta é obrigatório')
    }

    if(!safeAsign(this.agencia.value)) {
      return showError('Campos Obrigatórios', 'O Campo Agência é obrigatório')
    }

    if(codigoBanco == '001' && !safeAsign(this.digitoAgencia.value)){
      return showError('Campos Obrigatórios', 'O Campo Dígito Agência é obrigatório')
    }

    if(!safeAsign(this.conta.value)) {
      return showError('Campos Obrigatórios', 'O Campo Conta é obrigatório')
    }

    if(!safeAsign(this.digitoConta.value)) {
      return showError('Campos Obrigatórios', 'O Campo Dígito Conta é obrigatório')
    }


    const digitoAgencia = codigoBanco === '001'
      ? `Dígito Agência: ${this.validateAgenciaNull(this.digitoAgencia.value)}`
      : '';


    let bancoText = `Você confirma os dados bancários
    a seguir para receber a sua solicitação de garantia?
    <div class="mt-3" style="display: flex; flex-direction: column; align-items: center; gap: 6px;">
      <div style="display: flex; gap:6px;">
        <span >Banco:</span>
        <span >${bancoSelecionado.nome}</span>
      </div>
      <div style="display: flex; gap:6px;">
        <span >Tipo Conta:</span>
        <span >${this.tipoConta.value}</span>
      </div>
      <div style="display: flex; gap:6px;">
        <span >Agência:</span>
        <span >${this.agencia.value}</span>
      </div>
      ${digitoAgencia}
      <div style="display: flex; gap:6px;">
        <span >Conta:</span>
        <span >${this.conta.value}</span>
      </div>
      <div style="display: flex; gap:6px;">
        <span >Dígito Conta:</span>
        <span >${this.digitoConta.value}</span>
      </div>
    </div>
    `

    Swal.fire({
      title: 'Confirme os Dados',
      html: bancoText,
      padding: '3rem',
      width: '700px',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: 'Confirmar',
      denyButtonText: 'Corrigir',
      confirmButtonColor:'#00A676',
      showDenyButton: true,
    }).then(result => {
      if (result.value){
        let body = {}

        if(this.query.tipoUsuario.toUpperCase() == 'entidade'.toUpperCase()){
          body = {
            codigoTransacao: generateUUID(),
            ativos: this.tableAtivos,
            nomeInvestidor: this.nome.value,
            isencaoIR: this.tipoEntidade.value.toUpperCase() != 'investidorFI'.toUpperCase() ? 0 : 1,
            celular: this.celular.value,
            telefone: this.telefone.value,
            instituicaoId: this.codCnpj.value,
            codCnpj: this.documentoIdentificador.value,
            email: this.email.value,
            endereco: this.endereco.value,
            complemento: this.complemento.value,
            bairro: this.bairro.value,
            cidade: this.cidade.value,
            estado: this.estado.value,
            cep: this.cepUsuario.value,
            pais: this.pais.value,
            codigoBanco: codigoBanco,
            agencia: this.agencia.value,
            tipoConta: this.tipoConta.value,
            conta: this.conta.value,
            dgConta: this.digitoConta.value,
            dgAgencia: this.digitoAgencia.value,
            tipoInvestidor: this.query.tipoUsuario.toUpperCase(),
          }
        }else{

          const cellphone = encryptStorage.getItem('@celular', false)
          const tellphone = encryptStorage.getItem('@telefone', false)
          const nomeEmpresaEscolhida = localStorage.getItem('nomeEscolhidoGarantiaDPGE')

          let docIdentifier = null;
          let nomeInvestidor = null;

          switch (this.query.tipoUsuario) {
            case 'INVESTIDORPF':
              docIdentifier = encryptStorage.getItem('@documentoIdentificador', false)
              nomeInvestidor = encryptStorage.getItem('@user', false)
              break;
            case 'INVESTIDORPJ':
            case 'INVESTIDORFI':
              docIdentifier = this.query.cnpjEmpresaEscolhidaCredor
              nomeInvestidor = nomeEmpresaEscolhida
              break;
          }

          body = {
            codigoTransacao: generateUUID(),
            ativos: this.tableAtivos,
            nomeInvestidor: nomeInvestidor,
            isencaoIR: this.query.tipoUsuario.toUpperCase() == 'investidorFI'.toUpperCase() ? 1 : 0,
            tipoInvestidor: this.query.tipoUsuario.toUpperCase(),
            celular: cellphone && cellphone !== "undefined" ? cellphone : null,
            telefone: tellphone && tellphone !== "undefined" ? tellphone : null ,
            instituicaoId: this.codCnpj.value,
            codCnpj: docIdentifier,
            email: encryptStorage.getItem('@email', false),
            endereco: this.endereco.value,
            complemento: this.complemento.value,
            bairro: this.bairro.value,
            cidade: this.cidade.value,
            estado: this.estado.value,
            cep: this.cepUsuario.value,
            pais: this.pais.value,
            codigoBanco: codigoBanco,
            agencia: this.agencia.value,
            tipoConta: this.tipoConta.value,
            conta: this.conta.value,
            dgConta: this.digitoConta.value,
            dgAgencia: this.digitoAgencia.value
          }
        }
        let query = {codigoTransacao:generateUUID()}

        return this.solicitarGarantiaService.realizarSolicitacaoGarantiaDPGE(body, query).subscribe(
          res => showSucess('','Sucesso ao realizar a solicitação de garantia'),
          e=> showDefaultError(e),
          () => {
            this.solicitarDpge = false
            this.createForm(new FormAtivo())
            this.tableAtivos = []
            this.createFormDadosInvestidor(new InvestidorEntidade())
            this.listarAtivos()
          }
        )
      }else if(result.dismiss){
        showError('','Revise os dados bancários e prossiga posteriormente')
      }
    })
  }

  validateAgenciaNull(agencia){
    if(agencia == null || agencia == undefined)
      return '0'
    else return agencia
  }

  listarBancos() {
    this.bancoService.listarBancos().subscribe(
      res => {
        this.bancos = res["data"]["bancos"];
        this.arrayBancos = this.bancos.map(banco => ({
        value: banco.id,
        label: `${banco.id} - ${banco.nome}`
      }));
    },
      e => console.log
    )
  }

  listarAtivos() {
    this.p = 1;
    const { codigoAtivo, documentoIdentificador } = this.formSearch.getRawValue();
    const docLength = documentoIdentificador.length;

    this.query.codigoAtivo = codigoAtivo;
    this.query.documentoIdentificador = documentoIdentificador;

    if (documentoIdentificador != "") {
        if (docLength < 14 && !cpf.isValid(documentoIdentificador)) {
          return showError(
            "CPF Inválido",
            "O documento identificador informado não é válido"
          );
        }

        if (docLength == 14 ) {
          try {
            this.formSearch.get("documentoIdentificador")?.setValue(CnpjValidator.create(documentoIdentificador));
          } catch {
            return showError(
              "CNPJ Inválido",
              "O documento identificador informado não é válido"
            );
          }
        }
    }

    if (this.query.tipoUsuario.toUpperCase() != "ENTIDADE") {
      if (!safeAsign(this.query.documentoIdentificador)) delete this.query.documentoIdentificador;
      if (!safeAsign(this.query.codigoAtivo)) delete this.query.codigoAtivo;
    }

    return this.solicitarGarantiaService
    .solicitarGarantiaDPGE(this.query)
    .subscribe(
      (res) => {
        this.tableCard = res?.data ?? [];
      },
      (e) => showDefaultError(e),
      () => {
        this.query.codigoAtivo = this.query.codigoAtivo ?? "";
        this.query.documentoIdentificador = this.query.documentoIdentificador ?? "";
      }
    );
}

  openModalDetalhar(dados){
    let config = {
      scroll: true,
      ignoreBackDropClick: true,
      data: {model: dados}
    }

    this.modalRef = this.modalService.show(ModalDetalhesAtivosComponent, config)
  }



  consultaEndereco(event) {
    let dadosEndereco
    if (this.cepUsuario.value.length == 8) {
      cep(this.cepUsuario.value, {
        timeout: 5000,
        providers: ['brasilapi']
      }).then(res => {
        dadosEndereco = res
        this.endereco.setValue(dadosEndereco.street)
        this.cidade.setValue(dadosEndereco.city)
        this.bairro.setValue(dadosEndereco.neighborhood)
        this.estado.setValue(dadosEndereco.state)
        this.pais.setValue('Brasil')
      }).catch(
        e => {
         return Swal.fire({
            title: e.message,
            width: '800px',
            padding: '2em',
            showCloseButton: true,
            showConfirmButton: true,
            html: `<p> CEP Não Encontrado </p>`,
            confirmButtonText: 'Corrigir'
          })
        }
      )
    } else {
      return console.log("CEP Inválido")
    }
  }

  isCPF(): boolean {
    let cpfCnpj =  this.documentoIdentificador.value;

    return cpfCnpj == null ? true : cpfCnpj.length < 12 ? true : false;
  }

  isBancoDoBrasil(): boolean {
    const removeEspaçosEmBrancoRegex = /\s/g
    return this.codigoBanco?.value?.replace(removeEspaçosEmBrancoRegex, '').toUpperCase() === '001-BANCODOBRASILS.A.';
  }

  getCpfCnpjMask(): string {
    return this.tipoEntidade.value == 'pessoaFisica' ? "AAA.AAA.AAA-AA" : "AA.AAA.AAA/AAAA-AA";
  }

  get nome(){
    return this.dadosInvestidor.get('nomeInvestidor')
  }

  get tipoEntidade(){
    return this.dadosInvestidor.get('tipoInvestidor')
  }

  get documentoIdentificador(){
    return this.dadosInvestidor.get('documentoIdentificador')
  }
  get email(){
    return this.dadosInvestidor.get('email')
  }

  get celular(){
    return this.dadosInvestidor.get('celular')
  }

  get telefone(){
    return this.dadosInvestidor.get('telefone')
  }

  get codigoBanco(){
    return this.formSolicitacao.get('codigoBanco')
  }
  get conta(){
    return this.formSolicitacao.get('conta')
  }
  get agencia(){
    return this.formSolicitacao.get('agencia')
  }

  get digitoConta(){
    return this.formSolicitacao.get('dgConta')
  }
  get digitoAgencia(){
    return this.formSolicitacao.get('dgAgencia')
  }
  get tipoConta(){
    return this.formSolicitacao.get('tipoConta')
  }

  get cepUsuario(){
    return this.formSolicitacao.get('cep')
  }
  get pais(){
    return this.formSolicitacao.get('pais')
  }

  get complemento(){
    return this.formSolicitacao.get('complemento')
  }
  get endereco(){
    return this.formSolicitacao.get('endereco')
  }
  get cidade(){
    return this.formSolicitacao.get('cidade')
  }

  get bairro(){
    return this.formSolicitacao.get('bairro')
  }
  get estado(){
    return this.formSolicitacao.get('estado')
  }

  get codCnpj(){
    return this.formSolicitacao.get('codCnpj')
  }

}
